module.exports = __webpack_public_path__ + "img/icon-wallet.d9ccfae1.svg";